module.exports = __webpack_public_path__ + "static/media/team-member-01.789a87e3.jpg";